// Pending "open Add Music" request: set by the Ctrl/Cmd+O shortcut, consumed by the
// library browser once mounted (it may still be loading when the key is pressed).
const REQUEST_TTL_MS = 10000;
let requestedAt = 0;
const listeners = new Set();

export function requestAddMusic() {
  requestedAt = Date.now();
  listeners.forEach((fn) => fn());
}

export function consumeAddMusicRequest() {
  const fresh = requestedAt > 0 && Date.now() - requestedAt < REQUEST_TTL_MS;
  requestedAt = 0;
  return fresh;
}

export function subscribeAddMusicRequest(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
